import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    checkbox: {
        id: 'new_cards.form_checkbox_first_part',
        defaultMessage: 'I have read and accept the',
    },
    offer: {
        id: 'new_cards.form_checkbox_offer_agreement',
        defaultMessage: 'Offer Agreement',
    },
    back: {
        id: 'new_cards.form.back',
        defaultMessage: 'Back',
    },
    edit: {
        id: 'new_cards.form.edit',
        defaultMessage: 'Edit',
    },
    getCard: {
        id: 'new_cards.form.get_card',
        defaultMessage: 'Get Card',
    },
})
